import { datadogLogs } from "@datadog/browser-logs";

const CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "LOCAL";

export const initDatadog = () => {
  if (!CLIENT_TOKEN || CLIENT_TOKEN === "YOUR_DATADOG_CLIENT_TOKEN") {
    console.warn("Datadog Client Token not set. Logging disabled.");
    return;
  }

  datadogLogs.init({
    clientToken: CLIENT_TOKEN,
    site: "datadoghq.eu",
    forwardErrorsToLogs: true,
    service: "frontend.ab-delivery-tracking",
    env: ENVIRONMENT,
    sessionSampleRate: 100,
  });
};

export const datadogLogger = datadogLogs.logger;
